/**
 * @desc BSG-LTC 送样单接口
 */

import request from "@/utils/request";

// 获取送样单列表
export function getSampleList(params) {
  return request({
    url: `/apt-css/order/bsg/ltc/sampleList/page`,
    method: "get",
    params,
  });
}

export function saveSampleList(data) {
  return request({
    url: `/apt-css/order/bsg/ltc/sampleList/submit`,
    method: "post",
    data,
    timeout: 60000,
  });
}